import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { capitalizeWords, capitalize } from "../../../utils/capitalize/capitalizeWord";
import {
    returnHome, 
    cert_function,
    uppdateCert,
  } from "../../../Redux/ActionCreator";
  import { saveIntoServerCache, getOneFromServerCache } from "../../../utils/saveIntoCache";
import { ToastContainer, toast } from 'react-toastify';


const EditCert = ({ handleClick }) => {
    const dispatch = useDispatch();
  const cert = useSelector(e => e.cert.cert);
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const profile = useSelector(e => e.profile);
  const [ certification, setCertification ] = useState([]);

  useEffect(() => {
    if (cert !== null && !window.location.pathname.includes("/user/profile")) {
      setCertification(cert)
    } else if (cert == null && !window.location.pathname.includes("/user/profile"))  {
      let cacheInfo = getOneFromServerCache("cert");
      cacheInfo.then(res => res.json())
        .then(res => {
          if (res.success === true) {
            if (res.data !== null && res.data !== undefined) {
              let resObj = JSON.parse(res.data);
              // console.log("respObj", resObj);
              dispatch(cert_function(resObj));
              setCertification(resObj);
            }
            // console.log("Done");
          } else if (res.success === false && res.message == "Unauthorized") {
            dispatch(returnHome(res.status));
          }
        }).catch(err => {
          // console.log("Error getting personal info", err)
        })
    } else if (window.location.pathname.includes("/user/profile")) {
      // that is update on the profile page
      console.log("certification", profile.message?.certification);
      if (profile.message?.certification !== null && profile.message?.certification?.length !== 0) {
        setCertification(profile.message?.certification);
        dispatch(cert_function(profile.message?.certification));
      }
    }
  }, []);

  const handleSaveCall = async () => {
    // handleNext(dispatch, firstName, lastName, nextStep);
    try {
      if (certification.length !== 0) {
        if (window.location.pathname.includes("/user/profile")) {
          dispatch(uppdateCert(cert))
        }
        handleClick();
      }
    } catch (error) {
        throw error
    }
  }

  const handleCertUpdate = (e, key) => {
    e.preventDefault();
    let allCert = [ ...certification];
    allCert[key] = capitalizeWords(e.target.value);
    setCertification(allCert);
    dispatch(cert_function(allCert));
    saveIntoServerCache("cert", allCert);
  }

  const handleAddNewCert = () => {
    let newCerts = [...certification, ""]; // Add new empty string to the array
    setCertification(newCerts); // Update state
    // 
  }

  console.log("Certification", cert);
  const[ showCertPlaceholder, setShowCertPlaceholder ] = useState(true);

  return (
    <div className="bg-transparent px-4 md:px-6 lg:px-8 xl:px-10 py-8 md:w-[70vw] vsm:w-[90vw] flex justify-center rounded-xl my-6 max-h-[90vh]">
        <div className="sm:max-w-[50vw] vsm:w-[90vw] gap-y-2 lg:gap-0 lg:h-full bg-white flex flex-col lg:justify-between rounded-lg p-6 md:p-8 h-full">
            <h2 className="text-xl font-semibold text-[#5843BD] mb-4 text-center">Edit Certificate.</h2>
            
            <div className="lg:w-full w-full flex-col lg:flex-row md:gap-8 my-2">
                {certification !== null && certification?.length !== 0 ? (
                  <>
                  {certification?.map((element, key) => (
                    <>
                    <div className="flex w-full vsm:my-6 md:my-4 vsm:justify-center lg:justify-start" key={key} >
                        <div className="w-full flex vsm:justify-center md:justify-start">
                            <div className="w-full">
                                <label htmlFor="cert" className="text-black font-medium text-sm mb-2">
                                    Name of certification
                                </label>
                                <input
                                type="text"
                                id="cert"
                                className="w-full border-2 border-[#777DEA54] rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                                value={element}
                                onChange={(e) => handleCertUpdate(e, key)}
                                placeholder={showCertPlaceholder == false ? "" : "E.g plumber"}
                                onFocus={() => setShowCertPlaceholder(false)}
                                onBlur={() => setShowCertPlaceholder(true)}
                                />
                            </div>
                        </div>
                    </div>
                    {certification?.indexOf(element) == certification?.length - 1 && (
                    <p className="text-[#5843BD] text-md font-semibold mb-6 cursor-pointer text-center" onClick={() => handleAddNewCert()}>
                        <em className="underline">Click here to add new certification</em>
                    </p>
                    )}
                    </>
                ))}
                </>
                ) : (
                  <p className="text-[#5843BD] text-md font-semibold mb-6 cursor-pointer text-center" onClick={() => handleAddNewCert()}>
                    <em className="underline">Click here to add new certification</em>
                  </p>
                )}
            </div>

            {/* Navigation Buttons */}
            <div className="flex lg:w-full w-full flex-col lg:flex-row md:gap-8 md:justify-between justify-center my-2">
              <div className="flex justify-between lg:max-w-[90vw] w-full">
                <button
                    onClick={handleClick}
                    className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4 px-4 rounded-md"
                >
                  <span className="notranslate" key={flowLanguage}>
                    {flowLanguage == "Spanish" ? (
                      "Cancelar"
                    ) : (
                      "CANCEL"
                    )}
                  </span>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="24" height="24" rx="12" fill="#FF6633"/>
                        <path d="M15.1893 18C15.1132 18 15.0412 17.9653 14.9938 17.9058L12.0561 14.2175C11.953 14.0881 11.7548 14.0927 11.6579 14.2269L9.00599 17.8964C8.95899 17.9615 8.88362 18 8.80337 18H6.07388C5.86606 18 5.74897 17.7612 5.87625 17.5969L10.132 12.1039C10.2027 12.0127 10.2017 11.8849 10.1297 11.7948L5.82441 6.40605C5.69361 6.24233 5.81018 6 6.01973 6H8.81098C8.88693 6 8.95877 6.03453 9.00621 6.09384L11.9435 9.76586C12.0469 9.89503 12.2449 9.89004 12.3416 9.75583L14.9727 6.10386C15.0197 6.03865 15.0952 6 15.1756 6H17.9053C18.1131 6 18.2302 6.23864 18.1031 6.40295L13.8676 11.8792C13.7971 11.9703 13.798 12.0978 13.8698 12.1879L18.1767 17.5942C18.3072 17.758 18.1906 18 17.9812 18H15.1893Z" fill="white"/>
                    </svg>

                </button>
                <button
                    onClick={handleSaveCall}
                    className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 px-4 rounded-md"
                >
                  <span className="notranslate" key={flowLanguage}>
                    {flowLanguage == "Spanish" ? (
                      "GUARDAR"
                    ) : (
                      "SAVE"
                    )}
                  </span>
                    <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
              </div>
          </div>
        
        </div>
        <ToastContainer />
    </div>
  );
};

export default EditCert;
